import { useSelector } from "react-redux";
import { Board } from "../modules/Shared/Components/Board";
import { hasNoPermission } from "../utils/helpers/userHelpers";
import { AuthenticationState } from "../interfaces/users";
import { useMemo } from "react";

export const Assembly = () => {
  const { user } = useSelector((state: AuthenticationState) => state);
  const hasPermission = useMemo(
    () => hasNoPermission("assemble", user),
    [user]
  );
  return (
    <>
      {hasPermission ? (
        <Board title="Montagem" type="assemble" />
      ) : (
        <>
          <div className="">
            O seu usuário não possui permissão para acessar este conteúdo
          </div>
        </>
      )}
    </>
  );
};
